import { BASE_CLASS_PREFIX } from '../base/constants';
const cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-collapse`
};
const strings = {
  iconPosition: ['left', 'right']
};
export { cssClasses, strings };